import { amountToDisplayValue, Flex, getDisplayDate, Text, Tooltip } from '@billy/design-system'
import { memo, ReactElement } from 'react'

import { getBankLineDescription } from '@features/bankTransactions/utils/getBankLineDescription'
import { BankLine } from '@modules-deprecated/bankReconciliation/types'
import { prefixAmount } from '@modules-deprecated/bankReconciliation/utils'

import { useIsTruncated } from '../../../../../../../../../../hooks'
import { getCurrentLocale } from '../../../../../../../../../../utils'
import * as Styled from './styles'

interface BankLinesListItemContentProps {
  bankLine: BankLine
  currencyId?: string
}

export const BankLinesListItemContent = memo(
  ({ bankLine, currencyId }: BankLinesListItemContentProps): ReactElement => {
    const { description, entryDate, amount, side } = bankLine
    const locale = getCurrentLocale()
    const bankLineAmount = prefixAmount({ side, amount })
    const isNegativeAmount = bankLineAmount < 0
    const shouldShowBankLineAmount = !!bankLineAmount && !!currencyId
    const displayDescription = getBankLineDescription(description)
    const [descriptionRef, isDescriptionTruncated] = useIsTruncated(displayDescription)

    const descriptionElement = (
      <Text weight="bold" truncate ref={descriptionRef}>
        {displayDescription}
      </Text>
    )

    return (
      <Styled.BankLinesListItemContentWrapper>
        <Flex justifyContent="space-between" alignItems="center">
          <Styled.BankLinesListItemDetails>
            <Flex flexDirection="column">
              {isDescriptionTruncated ? (
                <Tooltip label={displayDescription} placement="top">
                  {descriptionElement}
                </Tooltip>
              ) : (
                descriptionElement
              )}
              <Text variant="bodySM" colorVariant="secondary">
                {getDisplayDate(new Date(entryDate), locale)}
              </Text>
            </Flex>
          </Styled.BankLinesListItemDetails>
          {shouldShowBankLineAmount && (
            <Styled.BankLinesListItemAmount>
              <Text colorVariant={isNegativeAmount ? 'danger' : 'success'} weight="bold">
                {amountToDisplayValue(bankLineAmount, false, currencyId)}
              </Text>
            </Styled.BankLinesListItemAmount>
          )}
        </Flex>
      </Styled.BankLinesListItemContentWrapper>
    )
  },
)
